function initPopup() {
	$('.popup-link').magnificPopup({
		type: 'inline'
	});
}